var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLandingPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Desktop-Chat--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Desktop Chat Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-chat--bubble-chat-customer-service-conversation-display-device"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 8v2.5c0 0.1326 -0.0527 0.2598 -0.1464 0.3536 -0.0938 0.0937 -0.221 0.1464 -0.3536 0.1464H1c-0.132608 0 -0.259785 -0.0527 -0.353553 -0.1464C0.552678 10.7598 0.5 10.6326 0.5 10.5v-8c0 -0.13261 0.052678 -0.25979 0.146447 -0.35355C0.740215 2.05268 0.867392 2 1 2h2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6 11 -1 2.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8 11 1 2.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 13.5h6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.5 5.5h3v2l3 -2h2v-5h-8v5Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLandingPages);
export default __webpack_public_path__ + "static/media/menu-landing-pages.7a4454b52516ac7aec989b357d71fdb7.svg";
export { ForwardRef as ReactComponent };